import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'Searchfilter'
})
export class Searchfilter implements PipeTransform {
    debugger;
    transform(items: any, value: string): any[] {
        debugger;
        if (!items) { return []; }
        if (!value) { return items; }
        // tslint:disable-next-line:no-unused-expression
        if (value === '' || value == null) { return items; }
        value = value.toLowerCase();
        debugger;
        return items.filteredData.filter(e =>
            e['SKUID'].toString().toLowerCase().indexOf(value) > -1
            ||       e['DeviceVendor'].toLowerCase().indexOf(value) > -1
            ||     e['DeviceModelID'].toString().toLowerCase().indexOf(value) > -1   
            ||     e['DeviceModelFullName'].toLowerCase().indexOf(value) > -1
            ||     e['StorageCapacity'].toString().toLowerCase().indexOf(value) > -1
            ||     e['MeasurementUnitType'].toLowerCase().indexOf(value) > -1
            ||     e['DeviceColor'].toLowerCase().indexOf(value) > -1
        );
    }
}